module.exports = __webpack_public_path__ + "img/R-9.73d7ff6f.png";